import React from 'react'
import { useParams } from "react-router-dom";
import { formatInspectionDateToYMD } from '../../prettyDate';
import './defects-overview.css'

export default function DefectsOverview({ defects }) {

    let { turbine_id } = useParams();
    turbine_id = parseInt(turbine_id);

    let { windfarm_id } = useParams();
    windfarm_id = parseInt(windfarm_id);

    const formatAction = (action) => {
        if (action === 'monitor') return 'Monitored';
        if(action ==='no_repair_needed') return 'Not repaired';
        return action.replace(/_/g, ' ').replace(/^./, c => c.toUpperCase());
    };


    return (
        <div className='defects-overview-container'>
            {
                defects?.length > 0 &&
                <>
                    <h2>Defects</h2>
                    <table className="user-action-table">
                        <thead className='user-action-table-header'>
                            <tr>
                                <th>Timestamp created</th>
                                <th>Blade</th>
                                <th>Repair status</th>
                                <th>Repair date</th>
                                <th>Defect id</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...defects]
                                .sort((a, b) => new Date(b.timestamp_created) - new Date(a.timestamp_created))
                                .map((defect) => (
                                    <tr key={defect.id}>
                                        <td>{formatInspectionDateToYMD(defect.timestamp_created)}</td>
                                        <td>{defect.blade}</td>
                                        <td>{formatAction(defect.repair_status)}</td>
                                        <td>{formatInspectionDateToYMD(defect?.repaired)}</td>
                                        <td><a
                                            title='Click to open on Wind Diagnostics'
                                            href={`/windfarm/${windfarm_id}/turbine/${turbine_id}`}
                                            target="_blank">{defect?.id}</a></td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </>
            }
        </div>
    )
}

